module.exports = __webpack_public_path__ + "img/color.1aec2d3.jpg";